import Cookies from 'js-cookie';
const LOCAL_STORAGE_KEY = "designatedclientevent"

const setClientEvent = (eventInfo) => {
    /* should look like this:
    { 
        clientId: '95e829d9-1dc3-4b23-a08d-2a25786c48b5', 
        eventId: '330436f5-e3de-ed11-a81c-00224853b513', 
        clientName: 'NAWLA', 
        eventName: '2023 Traders Market', 
        leadCaptureId: Guid,
        leadCaptureName: LC Name,
        expiration: 1718399263431,
        useFlatSetup: true
    }
    */
    // have to extract lead capture info, if same client
    let oldInfo = Cookies.get(LOCAL_STORAGE_KEY);
    if (oldInfo) {
        oldInfo = JSON.parse(oldInfo);
    }
    if (oldInfo && oldInfo.clientId && oldInfo.clientId !== undefined) {
        if (oldInfo.leadCaptureId && oldInfo.leadCaptureId !== undefined) {
            if (eventInfo.clientId === oldInfo.clientId) {
                if (eventInfo.leadCaptureId !== undefined && eventInfo.leadCaptureId !== oldInfo.leadCaptureId) {
                    // replace with new
                }
                else if (eventInfo.leadCaptureId === undefined && oldInfo.leadCaptureId !== undefined) {
                    // if same client, but event is not assigned, use the saved event - unless one is passed
                    // keep old lead capture info
                    eventInfo.leadCaptureId = oldInfo.leadCaptureId;
                    eventInfo.leadCaptureName = oldInfo.leadCaptureName;
                }
                else {
                    // keep old lead capture info
                    eventInfo.leadCaptureId = oldInfo.leadCaptureId;
                    eventInfo.leadCaptureName = oldInfo.leadCaptureName;
                }
            }
        }
        if (oldInfo.eventId && oldInfo.eventId !== undefined) {
            if (eventInfo.clientId === oldInfo.clientId) {
                if (eventInfo.eventId !== undefined && (eventInfo.eventId !== oldInfo.eventId || eventInfo.useFlatSetup !== oldInfo.useFlatSetup)) {
                    // replace with new
                }
                else if (eventInfo.eventId === undefined && oldInfo.eventId !== undefined) {
                    // if same client, but event is not assigned, use the saved event - unless one is passed
                    // keep old event info
                    eventInfo.eventId = oldInfo.eventId;
                    //eventInfo.eventName = oldInfo.eventName;
                    eventInfo.useFlatSetup = oldInfo.useFlatSetup !== undefined ? oldInfo.useFlatSetup : false;
                }
                else {
                    // keep old event info
                    eventInfo.eventId = oldInfo.eventId;
                   // eventInfo.eventName = oldInfo.eventName;
                    eventInfo.useFlatSetup = oldInfo.useFlatSetup !== undefined ? oldInfo.useFlatSetup : false;
                }
            }
        }
    }
    // set expiration date
    let dateExpires = new Date();
    dateExpires.setTime(dateExpires.getTime() + (1000 * 60 * 60 * 24 * 4)); // expires in 4 days
    //eventInfo.expires = dateExpires.toUTCString() 
    //localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(eventInfo))
    Cookies.set(LOCAL_STORAGE_KEY, JSON.stringify(eventInfo), { path: '/', expires: dateExpires });
    window.dispatchEvent(new CustomEvent('clientEventChange', { detail: eventInfo }));
}

const getClientEvent = () => {
    let eventInfo = Cookies.get(LOCAL_STORAGE_KEY);
    //let eventInfo = localStorage.getItem(LOCAL_STORAGE_KEY)
    //if (eventInfo) {
    //    const payload = JSON.parse(eventInfo)
    //    //payload.exp < Date.now() / 1000
    //    if (payload.expiration < Date.now() / 1000) {
    //        localStorage.removeItem(LOCAL_STORAGE_KEY)
    //        eventInfo = null
    //    }
    //} else {
    //    localStorage.removeItem(LOCAL_STORAGE_KEY)
    //}
    return eventInfo && eventInfo !== undefined? JSON.parse(eventInfo) : null
}

const getClientIdFromSaved = () => {
    const clientevent = getClientEvent()
    return clientevent
        ? clientevent.clientId
        : null
}

const getClientNameFromSaved = () => {
    const clientevent = getClientEvent()
    return clientevent
        ? clientevent.clientName
        : null
}

const getEventIdFromSaved = () => {
    const clientevent = getClientEvent()
    return clientevent
        ? clientevent.eventId
        : null
}

const getEventNameFromSaved = () => {
    const clientevent = getClientEvent()
    return clientevent
        ? clientevent.eventName
        : null
}

const getLeadCaptureIdFromSaved = () => {
    const clientevent = getClientEvent()
    return clientevent
        ? clientevent.leadCaptureId
        : null
}

const getLeadCaptureNameFromSaved = () => {
    const clientevent = getClientEvent()
    return clientevent
        ? clientevent.leadCaptureName
        : null
}
const getUseFlatSetupFromSaved = () => {
    const clientevent = getClientEvent()
    return clientevent
        ? clientevent.useFlatSetup 
        : null
}

const removeClientEvent = () => {
    let eventInfo = Cookies.get(LOCAL_STORAGE_KEY);
    if (eventInfo && eventInfo !== undefined) {
        //localStorage.removeItem(LOCAL_STORAGE_KEY)
        Cookies.remove(LOCAL_STORAGE_KEY);
    }
}

export {
    setClientEvent,
    getClientIdFromSaved,
    getEventIdFromSaved,
    getClientNameFromSaved,
    getEventNameFromSaved,
    getLeadCaptureIdFromSaved,
    getLeadCaptureNameFromSaved,
    getUseFlatSetupFromSaved,
    getClientEvent,
    removeClientEvent
}